<template>
  <div>
    <Header
      title="Push Web"
      subtitle="Envie mensagens via notificações Web"
      :has-separator="false"
    />

    <ValidationObserver>
      <div class="d-flex responvive-short-card">
        <v-card class="pa-8 mb-6 mr-6" :style="openResponse ? 'height: 830px' : 'height: 880px'" style="width: 826px">
          <v-col class="d-flex flex-column">
            <ValidationProvider
              class="d-flex flex-column"
              rules="required"
              v-slot="{ errors }"
            >
              <span class="font-weight-black" for="name">
                Título da Mensagem
              </span>
              <input class="input-field pl-2 mt-2" placeholder="Título da Mensagem" v-model="model.title" name="titulo"/>
              <span class="input-error">
                {{ errors[0] }}
              </span>
            </ValidationProvider>

            <ValidationProvider
              class="d-flex flex-column"
              rules="required"
              v-slot="{ errors }"
            >
              <span class="font-weight-black mt-5" for="name">
                Url de redirecionamento
              </span>
              <input class="input-field pl-2 mt-2" placeholder="Ex: https://www.empircus.com.br/" v-model.trim="model.url" name="url"/>
              <span class="input-error">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
            <div class="d-flex flex-row align-center">
              <v-switch
                color="var(--blue)"
                inset
                v-model="checkbox.shortenerUrlMain"
                @change="requestShort"
              ></v-switch>
              <span class="font-weight-black">Encurtar Url</span>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <img v-on="on"
                    class="ml-6" src="../../../../static/images/warning_blue.svg" />
                </template>
                <span>Ao habilitar esta opção, a url encurtada será enviada no disparo.</span>
              </v-tooltip>
            </div>
            <span class="d-flex flex-column" v-if="openResponse">
              <span class="font-weight-black">
                Url Encurtada
              </span>
              <input class="input-field pl-2 mt-2" v-model.trim="shorterUrl"/>
            </span>
            <span class="font-weight-black mt-3">
              Texto da Mensagem <span style="fontSize: 12px; color: var(--grey-day-040)">{{messageSize || 0}} / 200</span>
            </span>
            <ValidationProvider
              class="d-flex flex-column"
              rules="required"
              v-slot="{ errors }"
            >
              <textarea
                v-model="model.message"
                outlined
                rows="20"
                maxlength="200"
                style="max-height: 200px"
                class="text-area-field input-field mt-3 pl-2"
                name="texto da mensagem"
              ></textarea>
              <span class="input-error">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
            <span class="font-weight-black mt-7">
              Lista de destinatários
            </span>
            <v-file-input
              chips
              flat
              style="width: 350px"
              color="var(--grey-day-030)"
              :show-size="1000"
              placeholder="Arquivo CSV"
              outlined
              class="mt-3"
              v-model="chosenFile"
            >
              <img src="../../../../static/images/send.svg">
            </v-file-input>
          </v-col>
        </v-card>

        <div class="responvive-card">
          <!-- Agendamento -->
          <div class="calendar-card">
            <v-card class="px-8 py-8 mb-6 schedule-card">
              <h4>Agendamento</h4>
              <p class="mt-1">Escolha data e hora para que o envio do SMS</p>
              <v-card class="d-flex flex-column calendarResponsive">
                <v-date-picker
                  v-model="model.date"
                  locale="pt-Br"
                  :hide-header="false"
                  no-title
                  :min="nowDate"
                ></v-date-picker>
                <span class="rounded ma-3 d-flex align-center justify-flex-start" style="border: 2px solid var(--grey-day-030); height: 48px;">
                  <img class="ma-3 " src="../../../../static/images/calendar.svg"/>{{ model.date === null ? dayMoment : formatDate(model.date)}}
                </span>
              </v-card>
              <v-col class="d-flex timeModelHour">
                <div v-if="windowScreen" :style="openResponse ? 'height: 200px;' : 'height: 170px; width: 350px'" class="pa-8 timeDurationCard">
                  <h4>Início do ciclo</h4>
                  <p class="mt-1">Agendamento de início</p>
                  <div class="d-flex flex-row align-center justify-space-between">
                    <span class="font-weight-black" >Horário</span>
                    <v-card width="220" height="56">
                      <v-text-field
                        v-model="model.hour"
                        height="58"
                        solo
                        value="09:00"
                        type="time"
                      ></v-text-field>
                    </v-card>
                  </div>
                </div>
                <span :class="windowScreen ? 'initialHours' : '' " class="pt-5 font-weight-black mr-4">Horário</span>
                <v-card :class="windowScreen ? 'initialHours' : '' " width="250" height="56" class="mt-5">
                  <v-text-field
                    height="58"
                    solo
                    value="09:00"
                    type="time"
                    v-model="model.hour"
                  ></v-text-field>
                </v-card>
                <div v-if="windowScreen" :style="openResponse ? 'height: 200px;' : 'height: 170px; width: 350px'" class="pa-8 timeDurationCard">
                  <h4>Tempo de vida</h4>
                  <p class="mt-1">Duração</p>
                  <div class="d-flex flex-row align-center justify-space-between">
                    <span class="font-weight-black" >Horário</span>
                    <v-card width="220" height="56">
                      <v-text-field
                        v-model="model.durationTime"
                        height="58"
                        solo
                        value="09:00"
                        type="time"
                      ></v-text-field>
                    </v-card>
                  </div>
                </div>
              </v-col>

              <!-- Dois -->
            </v-card>

            <v-card v-if="!windowScreen" :style="openResponse ? 'height: 200px' : 'height: 170px'" class="pa-8 timeDuration">
              <h4>Tempo de vida</h4>
              <p class="mt-1">Duração</p>
              <div class="d-flex flex-row align-center justify-space-between">
                <span class="font-weight-black" >Horário</span>
                <v-card width="220" height="56">
                  <v-text-field
                    v-model="model.durationTime"
                    height="58"
                    solo
                    value="09:00"
                    type="time"
                  ></v-text-field>
                </v-card>
              </div>
            </v-card>
          </div>
        </div>
      </div>
    </ValidationObserver>

    <!-- Ultimo card da tela -->
    <v-card height="auto" class="showImagesCard">
      <v-col class="d-flex flex-column align-start px-8 pt-8">

        <!-- IMAGEM -->
        <v-row class="align-center pl-3 ">
          <v-switch
            color="var(--blue)"
            inset
            v-model="showImage"
          ></v-switch>
          <span class="font-weight-black">Exibir imagem de texto.</span>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <img v-on="on"
                class="ml-6" src="../../../../static/images/warning_blue.svg" />
            </template>
            <span>Resolução Mínima 360x240 - Resolução Recomendada 720x480
            Suportada no CHROME (Somente Windows Desktop e ANDROID)</span>
          </v-tooltip>
        </v-row>

        <v-row v-if="showImage" class="showImagesCard--image">
          <v-col>
            <span class="font-weight-black mt-5">
              Tipo da imagem
            </span>
            <v-select
              v-model="type"
              :options="listTypes"
              placeholder="Via Url"
              class="mt-3 pt-2 mb-5 input-field imageField"
              style="color: var(--gray-day-020)"
            />

            <span v-if="type === 'Via Upload'" style="display: flex; flex-direction: column">
              <span class="font-weight-black mt-2">
                Arquivo
              </span>

              <div
                class="image-input"
                @click="chooseImage"
              >
                <span class="placeholder">
                  {{imageName ? imageName : `Escolha o Arquivo`}}
                </span>
                <input
                  accept="image/png,image/jpg,image/jpeg"
                  class="file-input"
                  ref="fileInput"
                  type="file"
                  @input="onSelectFile"
                >
              </div>
            </span>

            <span v-if="type === 'Via Url'">
              <span class="font-weight-black d-flex flex-column mt-3" for="name">
                Url da imagem
              </span>
              <input v-model="model.imageUrl" class="input-field imageField pl-2 mt-3" placeholder="Título da Mensagem"/>
            </span>
          </v-col>
          <v-col class="d-flex align-center justify-center">
            <img style="max-width: 230px" :src="type === 'Via Upload' ? previewMainImage : model.imageUrl" />
          </v-col>
        </v-row>
        <!-- IMAGEM -->

        <!-- ÍCONE -->
        <v-row class="align-center pl-3 ">
          <v-switch
            color="var(--blue)"
            inset
            v-model="showIcon"
          ></v-switch>
          <span class="font-weight-black">Exibir Ícone no lado esquerdo do push.</span>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <img v-on="on"
                class="ml-6" src="../../../../static/images/warning_blue.svg" />
            </template>
            <span>Resolução Mínima 80x80 - Resolução Recomendada 256x256
            Suportada no CHROME (Somente Windows Desktop e ANDROID)</span>
          </v-tooltip>
        </v-row>

        <v-row v-if="showIcon" class="showImagesCard--icon">
          <v-col>
            <span class="font-weight-black mt-5">
              Tipo do ícone
            </span>
            <v-select
              v-model="typeIcon"
              :options="listTypes"
              placeholder="Via Url"
              class="mt-3 pt-2 mb-5 input-field imageField"
              style="color: var(--gray-day-020)"
            />
            <span v-if="typeIcon === 'Via Upload'">
              <span class="font-weight-black mt-7">
                Arquivo
              </span>
              <div
                class="image-input"
                @click="chooseIcon"
              >
                <span class="placeholder">
                  {{imageIconName ? imageIconName : 'Escolha o arquivo'}}
                </span>
                <input
                  accept="image/png,image/jpg,image/jpeg"
                  class="file-input"
                  ref="fileInputIcon"
                  type="file"
                  @input="onSelectFileIcon"
                >
              </div>
            </span>
            <span v-if="typeIcon === 'Via Url'">
              <span class="font-weight-black d-flex flex-column mt-3" for="name">
                Url da imagem
              </span>
              <input v-model="model.iconButton1Url" class="input-field imageField pl-2 mt-3" placeholder="Título da Mensagem"/>
            </span>
          </v-col>
          <v-col class="d-flex align-center justify-center">
            <img style="max-width: 230px" :src="typeIcon === 'Via Upload' ? previewMainIcon : model.iconButton1Url" />
          </v-col>
        </v-row>
        <!-- ÍCONE -->


        <!-- BOTÕES -->
        <v-row class="align-center pl-3 ">
          <v-switch
            color="var(--blue)"
            inset
            v-model="showBtn"
          ></v-switch>
          <span class="font-weight-black">Botões.</span>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <img v-on="on"
                class="ml-6" src="../../../../static/images/warning_blue.svg" />
            </template>
            <span>Resolução Mínima 80x80
              Suportada no CHROME (Somente Windows Desktop)</span>
          </v-tooltip>
        </v-row>


        <!-- PRIMEIRO BOTÃO -->
        <v-row v-if="showBtn" class="showImagesCard--icon">
          <v-col>
            <span class="font-weight-black d-flex flex-column mt-3" for="name">
              Texto do Botão
            </span>
            <input v-model="model.button1.text" class="input-field imageField pl-2 mt-3" placeholder="Texto do Botão"/>
            <span class="font-weight-black d-flex flex-column mt-3" for="name">
              Url de redirecionamento do Botão
            </span>
            <input v-model="model.button1.url" class="imageField input-field pl-2 mt-3" placeholder="Url de redirecionamento do Botão"/>
            <span class="font-weight-black mt-5 d-flex flex-column">
              Tipo do ícone
            </span>
            <v-select
              v-model="typeIconButton"
              :options="listTypes"
              placeholder="Via Url"
              class="mt-3 pt-2 mb-5 input-field imageField"
              style="color: var(--gray-day-020)"
            />
            <span v-if="typeIconButton === 'Via Upload'">
              <span class="font-weight-black mt-7">
                Arquivo
              </span>
              <div
                class="image-input"
                @click="chooseBuutonIcon"
              >
                <span class="placeholder">
                  {{imageButtomName ? imageButtomName : 'Escolha o arquivo'}}
                </span>
                <input
                  accept="image/png,image/jpg,image/jpeg"
                  class="file-input imageField"
                  ref="fileInputIconButton"
                  type="file"
                  @input="onSelectFileIconButton"
                >
              </div>
            </span>
            <span v-if="typeIconButton === 'Via Url'">
              <span class="font-weight-black d-flex flex-column mt-3" for="name">
                Url da imagem
              </span>
              <input v-model="previewMainIconButton" class="imageField input-field pl-2 mt-3" placeholder="Link da imagem"/>
            </span>
          </v-col>
          <v-col class="d-flex align-center justify-center">
            <img style="max-width: 230px" :src="typeIconButton === 'Via Upload' ? model.button1.icon : previewMainIconButton" />
          </v-col>
        </v-row>
        <!-- PRIMEIRO BOTÃO -->


        <v-col v-if="showBtn" class="pl-0">
          <v-divider class="mt-9"></v-divider>
          <v-btn @click="secondBtn" depressed color="var(--white)" class="mt-2 pa-5">
            <img class="pa-2" style="width: 32px" :src="showSecondBtn ? '../../../../static/images/remove_red.svg' : '../../../../static/images/add-circle-black.svg'"/><span class="ff" :style="showSecondBtn ? 'color: var(--red)' : ''">{{buttonLabel}}</span>
          </v-btn>
        </v-col>

        <!-- Segundo botão -->
        <v-row v-if="showSecondBtn" class="showImagesCard--icon">
          <v-col >
            <span class="font-weight-black d-flex flex-column mt-3" for="name">
              Texto do Botão
            </span>
            <input v-model="model.button2.text" class="input-field imageField pl-2 mt-3" placeholder="Texto do Botão"/>
            <span class="font-weight-black d-flex flex-column mt-3" for="name">
              Url de redirecionamento do Botão
            </span>
            <input v-model="model.button2.url" class="input-field imageField pl-2 mt-3" placeholder="Url de redirecionamento do Botão"/>
            <span class="font-weight-black mt-5 d-flex flex-column">
              Tipo do ícone
            </span>
            <v-select
              v-model="typeIconButtonSecond"
              :options="listTypes"
              placeholder="Via Url"
              class="mt-3 pt-2 mb-5 input-field imageField"
              style="color: var(--gray-day-020)"
            />
            <span v-if="typeIconButtonSecond === 'Via Upload'">
              <span class="font-weight-black mt-7">
                Arquivo
              </span>
              <div
                class="image-input"
                @click="chooseSecondBuutonIcon">
                <span class="placeholder">
                  {{imageSecondButtomName ?  `${imageSecondButtomName}` : 'Escolha o arquivo'}}
                </span>
                <input
                  accept="image/png,image/jpg,image/jpeg"
                  class="file-input imageField"
                  ref="fileInputIconButtonSecond"
                  type="file"
                  @input="onSelectFileIconSecondButton"
                >
              </div>
            </span>
            <span v-if="typeIconButtonSecond === 'Via Url'">
              <span class="font-weight-black d-flex flex-column mt-3" for="name">
                Url da imagem
              </span>
              <input v-model="previewMainIconButton2" class="input-field imageField pl-2 mt-3" placeholder="Link da imagem"/>
            </span>
            <div class="d-flex mt-3 align-center">
              <img class="mr-6" src="../../../../static/images/warning_blue.svg" />
              <span style="font-size: 12px"> Resolução Mínima 80x80
              Suportada no CHROME (Somente Windows Desktop)</span>
            </div>
          </v-col>
          <v-col class="d-flex align-center justify-center">
            <img style="max-width: 230px" :src="typeIconButtonSecond === 'Via Upload' ? model.button2.icon : previewMainIconButton2" />
          </v-col>
        </v-row>
        <!-- Segundo botão -->

        <!-- BOTÕES -->
      </v-col>
    </v-card>

    <!-- Card enviar -->
    <v-card class="d-flex flex-row mt-8 justify-space-between align-center pa-7 mb-8 responsive-send-card" height="72px" color="var(--grey-day-070">
      <span class="white--text">Este disparo estará disponível dentro de Agendamentos. Se necessário poderá ser alterado ou cancelado.</span>
      <v-btn
        height="48"
        width="220"
        class="px-3 py-3"
        @click="sendPushNotification"
      >
        <img src="../../../../static/images/save.svg"/>
        <span class="pl-3 py-3 text-capitalize"> Push Notificação </span>
      </v-btn>
    </v-card>
    <div style="height: 20px"></div>
  </div>
</template>
<script>
// Lib
import { mapActions, mapState, mapMutations } from 'vuex'
import moment from 'moment'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// Components
import Header from '@/components/Header.vue'
// Token
import VueCookies from 'vue-cookies'
// mixins
import date from '../../../mixins/date'

export default {
  components: {
    Header,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [
    date
  ],
  data () {
    return {
      imageName: '',
      imageIconName: '',
      imageButtomName: '',
      imageSecondButtomName: '',
      imageData: null,
      imageDataIcon: null,
      imageDataIconButton: null,
      imageDataIconSecondButton: null,
      nowDate: new Date().toISOString().slice(0,10),
      time: null,
      timeToLive: null,
      type: 'Via Url',
      typeIcon: 'Via Url',
      typeIconButton: 'Via Url',
      typeIconButtonSecond: 'Via Url',
      listTypes: ['Via Upload', 'Via Url'],
      disabledButton: true,
      showImage: false,
      showIcon: false,
      showBtn: false,
      showSecondBtn: false,
      buttonLabel: 'Adicionar novo Botão',
      urlLong: '',
      shorterUrl: '',
      openResponse: false,
      previewMainImage: '',
      previewMainIcon: '',
      previewMainIconButton: '',
      previewMainIconButton2: '',
      dataDuration: null,
      model: {
        title: '',
        message: '',
        url: '',
        file: '',
        image: null,
        imageUrl: null,
        icon: null,
        iconUrl: null,
        date: null,
        durationTime: '01:00',
        hour: '00:00',
        button1: {
          id: '1',
          text: null,
          icon: null,
          url: null
        },
        button2: {
          id: '2',
          text: null,
          icon: null,
          url: null
        },
        iconButton1: null,
        iconButton1Url: null,
        iconButton2: null,
        iconButton2Url: null,
        timeToLiveSeconds: null,
      },
      checkbox: {
        shortenerUrlMain: false,
      },
      titleMsg: false,
      chosenFile: null
    }
  },
  computed: {
    ...mapState('UrlTools', {
			url: 'url',
			shortUrl: 'shortUrl'
		}),
    dayMoment () {
      return moment().format('DD/MM/YYYY')
    },
    messageSize () {
      return this.model.message.length
    },
    windowScreen () {
      return window.screen.width < 1377
    }
  },
  methods: {
    ...mapActions('UrlTools',{
			requestUrl: 'requestUrl'
		}),
    ...mapActions('PushWebLogs',{
			postNewPushWeb: 'postNewPushWeb'
		}),
    ...mapMutations('Shared', {
			setToaster: 'SET_TOASTER'
		}),
		toaster(message, color, visible) {
			this.setToaster({
				message,
				color,
				visible
			})
		},
    secondBtn () {
      if (!this.showSecondBtn) this.buttonLabel = 'Remover Segundo Botão'
      if (this.showSecondBtn) this.buttonLabel = 'Adicionar novo Botão'
      this.showSecondBtn = !this.showSecondBtn
    },
    async requestShort () {
      const token = VueCookies.get('jwt-login')

			try {
				const urlLongWhiteSpace = this.model.url.split(' ')
				if (urlLongWhiteSpace.length > 1) {
					this.toaster(
						'URL contém espaço em branco',
						'danger',
						true
					)
					return
				} else {
					const response = await this.requestUrl([
						{
							longUrl: this.model.url
						},
						token
					])
					this.shorterUrl = this.url.shortUrl
					this.openResponse =  true
					if (response.status >= 400) {
						throw new Error(response.data.message)
					} else {
						this.toaster(
							'URL encurtada com sucesso',
							'var(--green)',
							true
						)
					}
				}
			} catch (e) {
        this.toaster(e.message, 'danger', true)
      }
    },
    async sendPushNotification () {
      const token = VueCookies.get('jwt-login')

      try {
        let playerId = ''
        var formData = new FormData();
        formData.append('file', this.chosenFile);
        formData.append('message', this.model.message)
        formData.append('playerId', playerId)

        if (this.checkbox.shortenerUrlMain) {
          formData.append('url', this.shorterUrl)
        } else {
          formData.append('url', this.model.url)
        }

        formData.append('title', this.model.title)

        if (this.type === 'Via Upload') {
          formData.append('image', this.model.image);
        } else {
          formData.append('imageUrl', this.model.imageUrl);
        }


        if (this.typeIcon === 'Via Upload') {
          formData.append('icon', this.model.icon);
        } else {
          formData.append('iconUrl', this.model.iconUrl);
        }

        if (this.showBtn) {
          var buttonData1 = '{"id": "", "text": "' + this.model.button1.text + '", "icon": "' + this.previewMainIconButton + '", "url": "' + this.model.button1.url + '"}';
          formData.append('button1', buttonData1);
          if (this.typeIconButton === 'Via Upload') {
            formData.append('iconButton1', this.model.iconButton1);
          } else {
            formData.append('iconButton1Url', this.model.iconButton1Url);
          }

          if (this.showSecondBtn) {
            var buttonData2 = '{"id": "", "text": "' + this.model.button2.text + '", "icon": "' + this.previewMainIconButton2 + '", "url": "' + this.model.button2.url + '"}';
            formData.append('button2', buttonData2);
            if (this.typeIconButtonSecond === 'Via Upload') {
              formData.append('iconButton2', this.iconButton2);
            } else {
              formData.append('iconButton2Url', this.model.iconButton2Url);
            }

          }
        }

        if (this.model.date === null) {
          this.toaster('Escolha uma data', 'var(--red)', true)
          return
        }

        if (this.model.date !== null || this.model.date !== '') {
          const day = `${this.model.date} ${this.model.hour}`
          var date = new Date(day);
          formData.append('scheduled-date', date);
        }

        // adicionar append do timeToLive
        if (this.timeToLive !== null) {
          formData.append('time-to-live', this.dataDuration);
        }

        const response = await this.postNewPushWeb([
          formData,
          token
        ])

        if (response.status >= 400) {
          this.toaster(
            'Problema na requisição',
            'var(--red)',
            true
          )
          return
        }
        if (response.status === 200) {
          this.toaster(
            'Push agendado com sucesso',
            'var(--green)',
            true
          )
          this.clearForm()
          this.$router.push({
            name: 'SchedulingMessage'
          })
        }
      }
      catch (error) {
        this.toaster(
          error.message,
          'var(--red)',
          true
        )
      }
    },

    clearForm () {
      this.model.title = ''
      this.model.url = ''
      this.checkbox.shortenerUrlMain = false
      this.model.message = ''
      this.chosenFile = null
      this.type = 'Via Url',
      this.typeIcon = 'Via Url',
      this.typeIconButton = 'Via Url',
      this.typeIconButtonSecond = 'Via Url',
      this.model.hour = '00:00'
      this.model.durationTime = '01:00'
      this.showBtn = false
      this.showImage = false
      this.previewMainImage = ''
      this.showIcon = false
      this.previewMainIcon = ''

      this.model.button1.text = ''
      this.model.button1.url = ''
      this.previewMainIconButton = ''
      this.model.button1.icons = ''

      this.model.button2.text = ''
      this.model.button2.url = ''
      this.previewMainIconButton2 = ''
      this.model.button2.icons = ''

      this.imageDataIcon = null
      this.imageIconName = null
      this.imageData = null
      this.imageName = null
      this.imageButtomName = null
      this.imageDataIconSecondButton = null
      this.imageSecondButtomName = null
    },

    chooseImage () {
      this.$refs.fileInput.click()
    },
    chooseIcon () {
      this.$refs.fileInputIcon.click()
    },
    chooseBuutonIcon () {
      this.$refs.fileInputIconButton.click()
    },
    chooseSecondBuutonIcon () {
      this.$refs.fileInputIconButtonSecond.click()
    },
    onSelectFile () {
      const input = this.$refs.fileInput
      const file = input.files[0]
      if (file) {
        this.imageName = file.name
        this.previewMainImage = URL.createObjectURL(file)
        this.model.image = file
      }
    },
    onSelectFileIcon () {
      const input = this.$refs.fileInputIcon
      const file = input.files[0]
      if (file) {
        this.model.icon = file
        this.previewMainIcon = URL.createObjectURL(file)
        this.imageIconName = file.name
      }
    },
    onSelectFileIconButton () {
      const input = this.$refs.fileInputIconButton
      const file = input.files[0]
      if (file) {
        this.model.iconButton1 = file
        this.previewMainIconButton = URL.createObjectURL(file)
        this.imageButtomName = file.name
      }
    },
    onSelectFileIconSecondButton () {
      const input = this.$refs.fileInputIconButtonSecond
      const file = input.files[0]
      if (file) {
        this.model.iconButton1 = file
        this.previewMainIconButton = URL.createObjectURL(file)
        this.imageButtomName = file.name

        this.imageSecondButtomName = file.name
        this.model.button2.icon = file
        this.previewMainIconButton2 = URL.createObjectURL(file)
      }
    },
  },
  watch: {
    windowScreen () {
      return window.screen.width < 1377
    },
    'model.title' () {
      if (this.model.title !== '' && this.model.message !== '' && this.model.url !== '' && this.chosenFile !== null && this.model.hour !== null) return this.disabledButton = false
      if (this.model.title === '' && this.model.message !== '' && this.model.url !== '' && this.chosenFile !== null && this.model.hour !== null) return this.disabledButton = true
    },
    'model.message' () {
      if (this.model.message !== '' && this.model.title !== '' && this.model.url !== '' && this.chosenFile !== null && this.model.hour !== null) return this.disabledButton = false
      if (this.model.message === '' && this.model.title !== '' && this.model.url !== '' && this.chosenFile !== null && this.model.hour !== null) return this.disabledButton = true
    },
    'model.url' () {
      if (this.model.url !== '' && this.model.title !== '' && this.model.message !== '' && this.chosenFile !== null && this.model.hour !== null) return this.disabledButton = false
      if (this.model.url === '' && this.model.title !== '' && this.model.message !== '' && this.chosenFile !== null && this.model.hour !== null) return this.disabledButton = true
    },
    'chosenFile' () {
      if (this.chosenFile !== null && this.model.title !== '' && this.model.url !== '' && this.model.message !== '' && this.model.hour !== null) return this.disabledButton = false
      if (this.chosenFile === null && this.model.title !== '' && this.model.url !== '' && this.model.message !== '' && this.model.hour !== null) return this.disabledButton = true
    },
    'model.hour' () {
      if (this.model.hour !== null && this.chosenFile !== null && this.model.title !== '' && this.model.url !== '' && this.model.message !== '') return this.disabledButton = false
      if (this.model.hour === null && this.chosenFile !== null && this.model.title !== '' && this.model.url !== '' && this.model.message !== '' ) return this.disabledButton = true
    },
    'model.durationTime' () {
      this.dataDuration = moment(this.model.durationTime, 'HH:mm').diff(moment().startOf('day'), 'seconds')
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--grey-day-030);
}

.v-snack__content {
  display: none
}

.ff {
  font-size: 12px;
  text-transform: capitalize;
}

.input-field {
  border: 2px solid var(--grey-day-030);
	border-radius: 4px;
  height: 48px
}
.responvive-short-card {
  flex-direction: row;
}
.text-area-field {
  height: 192px;
}
.btn {
  color: var(--white);
  margin-top: 28px;
}
.calendar-card {
  width: 372px;
}

.schedule-card {
  height: auto;
}

.showImagesCard--image,
.showImagesCard--icon {
  width: 100%;
}

.showImagesCard--icon {
  margin-bottom: 15px;
}

.imageField {
  width: 500px;
}

.calendarResponsive {
  width: 330px
}

.timeModelHour {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  width: 336px
}

.initialHours {
  display: none
}


@media screen and (max-width: 1377px) {
  .timeModelHour {
    align-items: center;
    display: flex !important;
    flex-direction: row;
    width: 100%
  }
  .initialHour {
    width: 230px;
  }
  .responsive-send-card, .showImagesCard {
    width: 830px
  }
  .responvive-short-card {
    display: flex;
    flex-direction: column;
  }
  .schedule-card {
    height: 800px;
    width: 100%;
  }
  .responvive-card {
    display: flex;
    flex-direction: row;
  }
  .calendar-card {
    display: flex;
    justify-content: center;
    margin-top: 0 !important;
    margin-left: 0;
    margin-right: 20px;
    margin-bottom: 20px;
    width: 100% !important;

  }
  .timeDuration {
    margin-left: 20px;
    width: 100%;
  }
  .timeDurationCard {
    margin-top: 50px
  }

  .imageField {
    width: 280px;
  }

  .calendarResponsive {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: auto
  }
}

.image-input {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 50px;
  cursor: pointer;
  border-style: solid;
  border-width: 2px;
  border-color: var(--grey-day-030);
  border-radius: 4px;
}

.placeholder {
  border-radius: 4px;
  background: #F0F0F0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333;
  font-size: 18px;
}

.placeholder:hover {
  background: #E0E0E0
}

.file-input {
  display: none;

}

.input-error {
  color: var(--red);
  font-size: 12px
}
</style>



// WEBPACK FOOTER //
// src/components/Contents/SendNotification/PushWeb.vue